import React, { useState } from 'react';
import { createRoot } from 'react-dom/client';

const Specjalizacje = () => {
    const [selected, setSelected] = useState(0);

    const handleClick = (index) => {
        setSelected(index);
    }

    return (
        <div className="wrapper grid-list__wrapper">
            <h1 className="page-title">Specjalizacje</h1>
            <div className="specjalizacje">
                {specjalizacje.map((element, index) =>
                    <div key={index} onClick={() => handleClick(index)} className="row">
                        <h3 className={`${selected === index ? "selected" : ""}`}>{element['name']}</h3>
                        {selected === index &&
                            <div className="content" dangerouslySetInnerHTML={{ __html: specjalizacje[selected].content() }}></div>
                        }
                    </div>
                )}
            </div>
        </div>
    );
}

const root = createRoot(document.getElementById('specjalizacje'));
root.render(<Specjalizacje />);
